module.exports = __webpack_public_path__ + "img/cehua.71aae0ec.svg";